import './util/polyfill';

export const audioContext: AudioContext | null =
  'AudioContext' in window
    ? new window.AudioContext({ latencyHint: 'interactive' })
    : null;
